"use client";

import { Info, InstagramLogo, LinkedinLogo, X, XLogo } from "@phosphor-icons/react/dist/ssr";

import Image from "next/image";
import Link from "next/link";
import { useState } from "react";
import { twMerge } from "tailwind-merge";

interface TeamCardProps {
  name: string;
  position?: string;
  description?: string;
  linkedIn?: string;
  twitter?: string;
  instagram?: string;
  photo?: string;
}

const TeamCard = ({ name, position, description, photo, linkedIn, twitter, instagram }: TeamCardProps) => {
  const [isDescriptionOpen, setIsDescriptionOpen] = useState<boolean>(false);

  return (
    <div className="rounded-2xl bg-[#0c1a31] w-60 h-80 sm:h-72 flex flex-col items-center relative overflow-hidden p-4">
      <Image
        src={photo || "/user-avatar-kolz.png"}
        alt={name}
        height={200}
        width={300}
        className="w-full object-cover rounded-full overflow-hidden"
      />
      <div
        className={twMerge(
          "bg-[#0c1a31] font-inter text-white absolute bottom-0 left-0 right-0 w-full py-2 px-3 transition-all duration-300 ease-in-out",
          isDescriptionOpen ? "h-full backdrop-blur-md" : "h-[100px]",
        )}
      >
        {!isDescriptionOpen && (
          <div className={twMerge(!position && "flex flex-col justify-between h-full")}>
            <h3 className="text-lg font-semibold">{name}</h3>
            {position && <p className="text-sm mt-1 mb-2">{position}</p>}
            <div className="flex items-center gap-3 text-xl">
              {description && <Info className="cursor-pointer" onClick={() => setIsDescriptionOpen(true)} />}
              {twitter && (
                <Link href={twitter} target="_blank" rel="noopener noreferrer">
                  <XLogo className="cursor-pointer" />
                </Link>
              )}
              {linkedIn && (
                <Link href={linkedIn} target="_blank" rel="noopener noreferrer">
                  <LinkedinLogo className="cursor-pointer" />
                </Link>
              )}
              {instagram && (
                <Link href={instagram} target="_blank" rel="noopener noreferrer">
                  <InstagramLogo className="cursor-pointer" />
                </Link>
              )}
            </div>
          </div>
        )}
        {isDescriptionOpen && (
          <>
            <X weight="bold" className="ml-auto cursor-pointer" onClick={() => setIsDescriptionOpen(false)} />
            <div className="overflow-y-auto px-1 pb-6 h-full no-scrollbar">{description}</div>
          </>
        )}
      </div>
    </div>
  );
};

export default TeamCard;
